module.exports = __webpack_public_path__ + "img/vertical-logo-white.93505a14.svg";